import { useLang } from "@/lib/i18n";

const WHATSAPP_NUMBER = "13608617655";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M16.004 3C8.83 3 3 8.77 3 15.89c0 2.5.73 4.93 2.1 7.03L3 29l6.27-2.02a13.1 13.1 0 0 0 6.73 1.84c7.17 0 13-5.77 13-12.9S23.17 3 16.004 3Zm0 23.55c-2.14 0-4.24-.58-6.06-1.68l-.43-.26-3.72 1.2 1.22-3.6-.28-.45a10.47 10.47 0 0 1-1.62-5.6c0-5.84 4.8-10.6 10.9-10.6 6.08 0 10.88 4.76 10.88 10.6s-4.8 10.6-10.89 10.6Zm5.97-7.93c-.33-.17-1.94-.95-2.24-1.06-.3-.11-.52-.17-.74.17-.22.33-.85 1.06-1.04 1.28-.19.22-.38.25-.71.08-.33-.17-1.38-.5-2.63-1.6-.97-.86-1.63-1.92-1.82-2.25-.19-.33-.02-.5.14-.67.15-.15.33-.39.49-.58.16-.19.22-.33.33-.55.11-.22.05-.42-.03-.58-.08-.17-.74-1.76-1.01-2.41-.27-.64-.54-.55-.74-.56h-.63c-.22 0-.58.08-.88.42-.3.33-1.15 1.12-1.15 2.72s1.18 3.16 1.34 3.38c.17.22 2.32 3.52 5.63 4.93.79.34 1.4.54 1.88.69.79.25 1.5.21 2.07.13.63-.09 1.94-.79 2.21-1.55.27-.76.27-1.42.19-1.55-.08-.14-.3-.22-.63-.39Z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t } = useLang();
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t("wa_message"))}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("wa_label")}
      className="group fixed right-4 sm:right-6 bottom-24 sm:bottom-6 z-40 flex items-center gap-3 rounded-full bg-[#25D366] text-white shadow-2xl shadow-black/30 pl-3.5 pr-3.5 sm:pr-5 h-14 transition-[transform,background-color] duration-200 hover:scale-105 hover:bg-[#1EBE5A] active:scale-95"
      data-testid="whatsapp-fab"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 pointer-events-none" />
      <WhatsAppIcon className="relative h-7 w-7" />
      <span className="relative hidden sm:block font-display font-bold text-sm whitespace-nowrap">
        {t("wa_cta")}
      </span>
    </a>
  );
};
